class UmButton extends HTMLElement {
   constructor() {
      super();
      // this.attachShadow({ mode: 'open' });

      const btn_wrap = document.createElement('a');
      btn_wrap.setAttribute("class", `button button-lg`);
      if (this.getAttribute('size')) {
        btn_wrap.setAttribute("size", this.getAttribute('size'));
      }
      this.href = this.getAttribute('href') ? this.getAttribute('href') : ''
      if (this.href) {
        btn_wrap.setAttribute("href", this.href);
      }

      const arrow = document.createElement('div');
      arrow.setAttribute("class", `custom-icon icon-arrow`);
      if (this.getAttribute('icon')) {
        arrow.setAttribute("icon", this.getAttribute('icon'));
      }

      const text = document.createElement('span');
      text.textContent = this.getAttribute('data-text') || 'button';

      const shadow = document.createElement('div');
      shadow.setAttribute("class", "shadow");

      btn_wrap.append(arrow, text, shadow);

      // Append the button and style to the shadow root
      // this.shadowRoot.appendChild(btn_wrap);
      this.appendChild(btn_wrap);


   }

    connectedCallback() {
      this.querySelector(".button").addEventListener("click", this.handleButtonClick.bind(this));
    }

    handleButtonClick(e) {
      if (!this.clickEvent) {
        return
      }
      e.preventDefault()
      if (this.clickEvent) {
        this.clickEvent()
      }

    }

}

customElements.define('um-button', UmButton);
